<div class="font-L fw-700">{{ 'page.settings.menu.account' | translate }}</div>

<!-- Global info -->
<div class="flex-center flex-column" style="margin-top: 50px; margin-bottom: 50px">
	<app-display-user-logo [user]="currentUser" [size]=50></app-display-user-logo>
	<div class="fw-600 font-MM mt-s">{{!currentUser ? '' : currentUser.account.firstName + ' ' + currentUser.account.lastName}}</div>
	<div class="grey">{{!currentUser ? '' : currentUser.account.email}}</div>
	<button *ngIf="currentUser" type="button" class="mt-s edit-profile-button c-p greyed-hover-2" (click)="openEditProfileDialog()">
		{{ 'page.settings.editProfile' | translate }}
	</button>
</div>

<!-- Change lang -->
<div class="divider"></div>
<div class="font-MM fw-700 mt-l">{{ 'page.account.changeLangTitle' | translate }}</div>
<div class="font-M mt-xs mb-s">{{ 'page.account.changeLangSubtitle' | translate }}</div>
<app-multi-select [inputControl]="langForm">
	<app-select-trigger appearance="field">{{getDefaultLang()}}</app-select-trigger>
	<app-select-option [value]="'en'">English</app-select-option>
	<app-select-option [value]="'fr'">Français</app-select-option>
</app-multi-select>

<!-- Weekly report -->
<div class="divider"></div>
<div class="flex-space-between flex-align-center">
    <div class="flex-column">
        <div class="font-MM fw-700">{{ 'page.account.weeklyReportTitle' | translate }}</div>
        <div class="font-M mt-xs">{{ 'page.account.weeklyReportSubtitle' | translate }}</div>
    </div>
    <app-toggle-button [toggleInput]="weeklyReportControl"></app-toggle-button>
</div>

<!-- Change password -->
<ng-container *ngIf="currentUser.account.provider === 'local'">
    <div class="divider"></div>
    <div class="font-MM fw-700 mt-l">{{ 'page.account.changePassword.title' | translate }}</div>
    <div class="font-M mt-xs mb-s">{{ 'page.account.changePassword.subtitle' | translate }}</div>
    <div class="disp-f f-d-col gap-S">
        <app-text-input type="password" [input]="$any(passwordForm.get('oldPassword'))" [placeholder]="'page.account.changePassword.input.oldPassword' | translate"></app-text-input>
        <app-text-input class="mt-s" type="password" [input]="$any(passwordForm.get('newPassword'))" [placeholder]="'page.account.changePassword.input.newPassword' | translate"></app-text-input>
        <app-text-input class="mt-s" type="password" [input]="$any(passwordForm.get('newPasswordConfirmation'))" [placeholder]="'page.account.changePassword.input.newPasswordConfirmation' | translate"></app-text-input>
        <div class="flex-column mt-s mb-s">
            <div *ngIf="password?.dirty"
                 [class.success]="password?.value?.match('.{12,}')"
                 class="flex-align-center">
                <img *ngIf="password?.value?.match('.{12,}')" style="padding-right: 1px" ngSrc="../../../../../assets/icons/check.svg" height="14" width="14" alt="check">
                <img *ngIf="!(password?.value?.match('.{12,}'))" class="pad-left-XS pad-right-XS" ngSrc="../../../../../assets/icons/ellipse.svg" height="5" width="5" alt="check">
                {{ 'page.signUp.passwordPolicy.minimumCharacterCount' | translate }}
            </div>

            <div *ngIf="password?.dirty"
                 [class.success]="password?.value?.match('^(?=.*[a-z])')"
                 class="flex-align-center">
                <img *ngIf="password?.value?.match('^(?=.*[a-z])')" style="padding-right: 1px" ngSrc="../../../../../assets/icons/check.svg" height="14" width="14" alt="check">
                <img *ngIf="!(password?.value?.match('^(?=.*[a-z])'))" class="pad-left-XS pad-right-XS" ngSrc="../../../../../assets/icons/ellipse.svg" height="5" width="5" alt="check">
                {{ 'page.signUp.passwordPolicy.lowercaseCharacter' | translate }}
            </div>

            <div *ngIf="password?.dirty"
                 [class.success]="password?.value?.match('^(?=.*[A-Z])')"
                 class="flex-align-center">
                <img *ngIf="password?.value?.match('^(?=.*[A-Z])')" style="padding-right: 1px" ngSrc="../../../../../assets/icons/check.svg" height="14" width="14" alt="check">
                <img *ngIf="!(password?.value?.match('^(?=.*[A-Z])'))" class="pad-left-XS pad-right-XS" ngSrc="../../../../../assets/icons/ellipse.svg" height="5" width="5" alt="check">
                {{ 'page.signUp.passwordPolicy.uppercaseCharacter' | translate }}
            </div>

            <div *ngIf="password?.dirty"
                 [class.success]="password?.value?.match('(.*[0-9].*)')"
                 class="flex-align-center">
                <img *ngIf="password?.value?.match('(.*[0-9].*)')" style="padding-right: 1px" ngSrc="../../../../../assets/icons/check.svg" height="14" width="14" alt="check">
                <img *ngIf="!(password?.value?.match('(.*[0-9].*)'))" class="pad-left-XS pad-right-XS" ngSrc="../../../../../assets/icons/ellipse.svg" height="5" width="5" alt="check">
                {{ 'page.signUp.passwordPolicy.numberCharacter' | translate }}
            </div>

            <div *ngIf="password?.dirty"
                 [class.success]="password?.value?.match('(.*[\\W_].*)')"
                 class="flex-align-center">
                <img *ngIf="password?.value?.match('(.*[\\W_].*)')" style="padding-right: 1px" ngSrc="../../../../../assets/icons/check.svg" height="14" width="14" alt="check">
                <img *ngIf="!(password?.value?.match('(.*[\\W_].*)'))" class="pad-left-XS pad-right-XS" ngSrc="../../../../../assets/icons/ellipse.svg" height="5" width="5" alt="check">
                {{ 'page.signUp.passwordPolicy.specialCharacter' | translate }}
            </div>
        </div>
        <app-text-button color="accent" type="flat" [loading]="isLoadingPasswordChange" [disabled]="!passwordForm.valid" (click)="onChangePassword()">{{ 'page.account.changePassword.title' | translate }}</app-text-button>
    </div>
</ng-container>

<!-- Delete account -->
<div class="divider" style="margin-bottom: 5px"></div>
<app-text-button color="danger" [disabled]="!currentUser" (click)="onDeleteAccount()">{{ 'page.account.deleteButton' | translate }}</app-text-button>
